var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from "vue";
import Component from "vue-class-component";
import { namespace } from "vuex-class";
import { Dependencies } from "~/core/decorator";
import { CaseOperatorPageService } from "~/services/domain-service/case-operator-page.service";
import AddCaseTelRecord from "~/components/collection-execution/operate-components/add-case-tel-record.vue";
import SendMessage from "~/components/collection-execution/operate-components/send-message.vue";
import SendMail from "~/components/collection-execution/operate-components/send-mail.vue";
import { Prop } from "vue-property-decorator";
import TelWater from "~/components/collection-execution/operate-components/tel-water.vue";
import { ApplyType, CASE_HALT_CATEGORY, MENU_CHANNEL, } from "~/config/enum.config";
import PauseApply from "~/components/apply-component/pause-apply.vue";
import AddContact from "~/components/collection-execution/operate-components/add-contact.vue";
import { RepairCasesService } from "~/services/domain-service/repair-cases.service";
import VisitActionArea from "~/components/collection-execution/collection-action-area/visit-action-area.vue";
import Apply from "~/components/visit-case/apply.vue";
var CollectionExecutionModule = namespace("collection-execution");
var TelephoneBook = /** @class */ (function (_super) {
    __extends(TelephoneBook, _super);
    function TelephoneBook() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.personalId = "";
        _this.dataSet = [];
        _this.dialog = {
            addCaseTelRecord: false,
            telWater: false,
            apply: false,
            contact: false,
            sendMessage: false,
            sendMail: false,
            addVisitCaseFollowupRecord: false,
        };
        _this.applyTypeChild = {};
        _this.phoneData = {
            phone: "",
        };
        _this.inputPhone = "";
        _this.contactsData = {};
        _this.caseHaltCategory = "";
        _this.applyType = ApplyType.pause;
        _this.selectionRow = null;
        _this.showInput = false;
        _this.otherModel = {
            caseHaltCategory: "",
            personalContractId: "",
        };
        _this.dialogVisible = false;
        return _this;
    }
    Object.defineProperty(TelephoneBook.prototype, "isTelShow", {
        get: function () {
            var _this = this;
            var arr = [MENU_CHANNEL.Tel_personal, MENU_CHANNEL.Tel_team];
            return arr.find(function (v) { return _this.menuChannel === v; });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TelephoneBook.prototype, "isVisitShow", {
        get: function () {
            var _this = this;
            var arr = [
                MENU_CHANNEL.Visit_personal,
                MENU_CHANNEL.Visit_team,
                MENU_CHANNEL.Assist_visit,
            ];
            return arr.find(function (v) { return _this.menuChannel === v; });
        },
        enumerable: false,
        configurable: true
    });
    TelephoneBook.prototype.onClickAddContact = function () {
        this.dialogVisible = true;
    };
    TelephoneBook.prototype.onSelectedRowChange = function (row) {
        this.selectionRow = row;
    };
    TelephoneBook.prototype.onFollowSuccess = function () {
        var _this = this;
        this.updateHistoryInfoActive("");
        this.updateAddRecordFlag(true);
        this.$nextTick(function () {
            _this.updateHistoryInfoActive("visit-action-history");
        });
    };
    TelephoneBook.prototype.success = function () {
        var _this = this;
        this.updateHistoryInfoActive("");
        this.updateAddRecordFlag(true);
        this.$nextTick(function () {
            _this.updateHistoryInfoActive("telephone-action-history");
        });
    };
    TelephoneBook.prototype.refreshData = function () {
        var _this = this;
        this.selectionRow = null;
        // 获取联系人信息
        this.caseOperatorPageService
            .personalContacts(this.caseId)
            .subscribe(function (data) {
            _this.dataSet = data;
        });
    };
    /**
     * 增加催收总结
     */
    TelephoneBook.prototype.addCaseTelRecord = function (rowData) {
        this.phoneData = {};
        if (rowData) {
            this.showInput = true;
            this.phoneData = rowData;
        }
        else {
            if (!this.inputPhone) {
                this.$message("请输入电话号码");
                return;
            }
            this.phoneData.phone = this.inputPhone;
            this.showInput = false;
        }
        this.dialog.addCaseTelRecord = true;
    };
    /**
     * 拨号
     */
    TelephoneBook.prototype.onCall = function (rowData) {
        this.phoneData = {};
        if (rowData) {
            this.phoneData = rowData;
        }
        else {
            if (!this.inputPhone) {
                this.$message("请输入电话号码");
                return;
            }
            this.phoneData.phone = this.inputPhone;
        }
        // 校验手机号码是否合规
        var phonereg = 11 && /^((13|14|15|16|17|18|19)[0-9]{1}\d{8})$/;
        if (!phonereg.test(rowData.phone)) {
            this.$message.error("号码格式错误，请核对手机号码！");
            return;
        }
        // 展开度言拨打界面
        var iconDoyanPhone = document.getElementById("icon-doyan-phone");
        var containerContentPhone = document.getElementById("container-content-phone");
        if (iconDoyanPhone && containerContentPhone) {
            if (containerContentPhone.style.display === "none") {
                iconDoyanPhone.click();
            }
            // DYSDK.init();
            // DYSDK.ready(function () {
            //   DYSDK.copy2cti(rowData.phone, function (data) {
            //     // console.log("号码复制成功！");
            //   });
            // });
            // // 接通电话的回调函数，返回电话号码等信息
            // DYSDK.callConfirm(function(data){
            //     console.log(data)
            //     // if(!data.uuid){
            //     //   alert("不存在uuid");
            //     // }
            // });
            // // 拨打电话失败的回调函数，返回电话号码等信息
            // DYSDK.callFail(function(data){
            //     // var id = localStorage.getItem('id');
            //     console.log(data)
            //     // console.log(id)
            //     // if(!data.uuid){
            //     //   alert("不存在uuid");
            //     // }
            // });
            // // 电话结束的回调函数，返回电话号码等信息
            // DYSDK.callEnd(function(data){
            //     console.log(data)
            //     // if(!data.uuid){
            //     //   alert("不存在uuid");
            //     // }
            // });
            // // 正在拨打中的回调函数，返回电话号码等信息
            // DYSDK.callConnecting(function(data){
            //     console.log(data);
            // });
            // // 编辑电话记录结束后的回调函数，返回电话号码等信息
            // DYSDK.wrapupEnd(function(data){
            //     console.log(data);
            //     // if(!data.uuid){
            //     //   alert("不存在uuid");
            //     // }
            // })
            // // CTI退出登录的回调函数
            // DYSDK.ctiLogout(function(data){
            //   console.log("成功退出拨号坐席！");
            // });
            // //登录成功后返回accountId.
            // DYSDK.ctiLogined(function(data){
            //   console.log(data, "登录成功");
            // });
            // DYSDK.callBridge(function(data){
            //   console.log(data);
            //   // if(!data.uuid){
            //   //     alert("不存在uuid");
            //   // }
            // });
            // DYSDK.getPhonelines(function(data){
            //   console.log(data);
            // });
        }
        // this.$message.success("拨号成功");
        // 展开催记弹框
        this.dialog.addCaseTelRecord = true;
    };
    /**
     * 发送短信
     */
    TelephoneBook.prototype.sendMessage = function (row) {
        this.contactsData = row;
        this.dialog.sendMessage = true;
    };
    /**
     * 发送邮件
     */
    TelephoneBook.prototype.sendMail = function (row) {
        this.contactsData = row;
        this.dialog.sendMail = true;
    };
    TelephoneBook.prototype.stopSMSClick = function () {
        if (!this.checkSelectedRow)
            return;
        if (this.selectionRow.pauseSms === "YES") {
            this.$message("短信已停催，无需重复申请");
            return;
        }
        this.otherModel.caseHaltCategory = CASE_HALT_CATEGORY.MESSAGE_HALT;
        this.dialog.apply = true;
    };
    TelephoneBook.prototype.stopTelClick = function () {
        if (!this.checkSelectedRow)
            return;
        if (this.selectionRow.pausePhone === "YES") {
            this.$message("电话已停催，无需重复申请");
            return;
        }
        this.otherModel.caseHaltCategory = CASE_HALT_CATEGORY.TEL_HALT;
        this.dialog.apply = true;
    };
    Object.defineProperty(TelephoneBook.prototype, "checkSelectedRow", {
        /**
         * 检测是否选中
         */
        get: function () {
            if (!this.selectionRow) {
                this.$message("请选择要操作的数据行");
                return false;
            }
            this.otherModel.personalContractId = this.selectionRow.id;
            return true;
        },
        enumerable: false,
        configurable: true
    });
    TelephoneBook.prototype.deleteClick = function (row) {
        var _this = this;
        return this.$confirm("\u786E\u8BA4\u5220\u9664\u5173\u8054\u4EBA\uFF1A" + row.contName + "?", '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
        }).then(function () {
            _this.caseOperatorPageService
                .deletePersonalContact(row.id)
                .subscribe(function (data) {
                _this.$message.success("删除成功");
                _this.refreshData();
            }, function (err) {
                _this.$message.success('操作失败!');
            });
        });
    };
    TelephoneBook.prototype.assistClick = function () {
        this.applyType = ApplyType.assist;
        this.dialog.apply = true;
        this.applyType.name = "外访协催";
    };
    TelephoneBook.prototype.addVisitCaseFollowupRecord = function (rowData) {
        if (rowData) {
            this.phoneData = rowData;
            this.dialog.addVisitCaseFollowupRecord = true;
        }
    };
    TelephoneBook.prototype.activated = function () {
        this.refreshData();
    };
    TelephoneBook.prototype.mounted = function () {
        this.refreshData();
    };
    __decorate([
        CollectionExecutionModule.Getter
    ], TelephoneBook.prototype, "collectonData", void 0);
    __decorate([
        Dependencies(CaseOperatorPageService)
    ], TelephoneBook.prototype, "caseOperatorPageService", void 0);
    __decorate([
        Dependencies(RepairCasesService)
    ], TelephoneBook.prototype, "repairCasesService", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], TelephoneBook.prototype, "caseId", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], TelephoneBook.prototype, "hiddenAction", void 0);
    __decorate([
        CollectionExecutionModule.State
    ], TelephoneBook.prototype, "menuChannel", void 0);
    __decorate([
        CollectionExecutionModule.Mutation
    ], TelephoneBook.prototype, "updateHistoryInfoActive", void 0);
    __decorate([
        CollectionExecutionModule.Mutation
    ], TelephoneBook.prototype, "updateAddRecordFlag", void 0);
    __decorate([
        Prop()
    ], TelephoneBook.prototype, "isView", void 0);
    __decorate([
        Prop()
    ], TelephoneBook.prototype, "isHiddenButton", void 0);
    TelephoneBook = __decorate([
        Component({
            components: {
                AddCaseTelRecord: AddCaseTelRecord,
                TelWater: TelWater,
                AddContact: AddContact,
                SendMessage: SendMessage,
                SendMail: SendMail,
                PauseApply: PauseApply,
                VisitActionArea: VisitActionArea,
                Apply: Apply,
            },
        })
    ], TelephoneBook);
    return TelephoneBook;
}(Vue));
export default TelephoneBook;
